import { gql } from "@apollo/client";

export const GET_MY_NOTIFICATIONS = gql`
  query getMyNotifications($page: Int, $pageSize: Int) {
    getMyNotifications(page: $page, pageSize: $pageSize) {
      unread
      notifications {
        page
        pageSize
        totalCount
        totalPages
        values {
          notificationId
          notificationBody
          notificationTitle
          sourceContextKeys {
            documentId
            siteId
          }
          sourceContextName
          isRead
          deliverymethod
        }
      }
    }
  }
`;
